import React, { Component } from 'react';
import Formulario from './TipoGastoForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class TipoGasto extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, getModulo, limpiarDatos } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4]);
        limpiarDatos();
    }
    
    render(){
        const { registroGasto, modificarGasto, loader, modulo, 
            lectura, listarCuentasContables, detalleTipoGasto, agregarLinea,
            agregarLineaCuenta, eliminarLinea, eliminarLineaCuenta, detalleTipo } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    registroGasto = {registroGasto}
                    crear = {crear}
                    modulo = {modulo}
                    lectura = {lectura}
                    modificarGasto = {modificarGasto}
                    listarCuentasContables = {listarCuentasContables}
                    detalleTipoGasto = {detalleTipoGasto}
                    agregarLinea = {agregarLinea}
                    agregarLineaCuenta = {agregarLineaCuenta}
                    eliminarLinea = {eliminarLinea}
                    eliminarLineaCuenta = {eliminarLineaCuenta}
                    detalleTipo = {detalleTipo}
                />
            </LoadMask>
        );
    }
}


export default TipoGasto;